import React, { ImgHTMLAttributes, SourceHTMLAttributes } from "react";
import { useNearViewport } from "@/hooks/useNearViewport";

interface DeferredImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  sources?: SourceHTMLAttributes<HTMLSourceElement>[];
}

/** Native lazy loading alone can still request pictures several screens away. */
export function DeferredImage({
  src,
  srcSet,
  sources,
  style,
  loading = "lazy",
  decoding = "async",
  ...props
}: DeferredImageProps) {
  const [ref, nearby] = useNearViewport<HTMLImageElement>();
  const image = (
    <img
      {...props}
      ref={ref}
      src={nearby ? src : undefined}
      srcSet={nearby ? srcSet : undefined}
      loading={loading}
      decoding={decoding}
      style={{ ...style, opacity: nearby ? style?.opacity : 0 }}
      data-deferred-image={nearby ? "ready" : "pending"}
    />
  );
  return sources ? (
    <picture>
      {sources.map((source, index) => (
        <source
          {...source}
          srcSet={nearby ? source.srcSet : undefined}
          key={index}
        />
      ))}
      {image}
    </picture>
  ) : (
    image
  );
}
